import * as React from 'react';
import styled from 'styled-components';

import { SPACING } from '../design-system/RunningText';

const Wrapper = styled.div`
  display: flex;
  margin-bottom: ${SPACING}px;
`;

interface LoomVideoProps {
  aspectratio?: string;
  className?: string;
  src: string;
}

export const LoomVideo: React.ComponentType<LoomVideoProps> = React.memo(
  ({ aspectratio, src, className }) => {
    return (
      <Wrapper
        className={className}
        style={{
          height: aspectratio ? 'auto' : '100%'
        }}>
        <div
          style={{
            position: 'relative',
            paddingBottom: aspectratio || '0',
            width: '100%',
            height: aspectratio ? 'auto' : '100%'
          }}>
          <iframe
            allowFullScreen={true}
            frameBorder="0"
            src={src}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }}
            title="Loom video"></iframe>
        </div>
      </Wrapper>
    );
  }
);
